import {Component} from 'react';

class RedirectPage extends Component {
    componentDidMount() {
        window.location.href = this.props.loc
    }
    render() {
        return null
    }
}
export default RedirectPage